import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import 'react-rangeslider/lib/index.css'
import 'react-intl-tel-input/dist/main.css'

class SignUp extends Component {
  state = {
    countryCode: this.props.country
  };

  handleCountryCode = () => {
    this.setState({
      countryCode: JSON.parse(localStorage.getItem('CountryCode'))
    })
  };

  componentDidMount () {
    if (localStorage.getItem('CountryCode')) {
      this.handleCountryCode()
    }
  }

  render () {
    return (
      <div className="signup">
        {this.state.countryCode === 'uk' || this.props.country === 'uk' ? (
          <>
            {this.props.action === 'button' ? (
              <NavLink to="/uk/try">
                <button
                  className={`btn inline my-3 mx-auto ${this.props.theme} `}
                >
                  {this.props.cta ? this.props.cta : 'Start Free Trial'}
                </button>
              </NavLink>
            ) : (
              ''
            )}
            {this.props.action === 'email' ? (
              <div className="signup__input-email flex items-center flex-wrap flex-col xs:flex-row">
                <NavLink to="/uk/try">
                  <button
                    className={
                      'btn btn__solid btn__orange rounded hover:cursor-pointer'
                    }
                  >
                    Create Free Account
                  </button>
                </NavLink>
              </div>
            ) : (
              ''
            )}
          </>
        ) : (
          <>
            {this.props.action === 'button' ? (
              <NavLink to="/try">
                <button
                  className={`btn inline my-3 mx-auto ${this.props.theme} `}
                >
                  {this.props.cta ? this.props.cta : 'Create Free Account'}
                </button>
              </NavLink>
            ) : (
              ''
            )}
            {this.props.action === 'email' ? (
              <div className="signup__input-email flex items-center flex-wrap flex-col xs:flex-row">
                <NavLink to="/try">
                  <button
                    className={
                      'btn btn__solid btn__orange rounded hover:cursor-pointer'
                    }
                  >
                    Create Free Account
                  </button>
                </NavLink>
              </div>
            ) : (
              ''
            )}
          </>
        )}
      </div>
    )
  }
}

export default SignUp
